import { setCookie } from 'PlugAndPlay/_global/js/cookieHelper';

export default function changeRegion(region) {
    setCookie('region-cookie', region);
    const currentURL = window.location.href;
    const URL_ROOT = 'energex.com.au/project-x';

    if (currentURL.indexOf('/seq') > -1 && region === 'qld') {
        window.location.href = window.location.href.replace('/seq', '/qld');
    } else if (currentURL.indexOf('/qld') > -1 && region === 'seq') {
        window.location.href = window.location.href.replace('/qld', '/seq');
    } else if (
        currentURL.indexOf('seq') <= -1 &&
        currentURL.indexOf('qld') <= -1
    ) {
        window.location.href = window.location.href.replace(
            URL_ROOT,
            `${URL_ROOT}/${region}`
        );
    }
}

export function getCurrentRegion() {
    const currentURL = window.location.href;
    // 4 will have to be updated when we get the proper URL
    // will contain 'seq', 'qld' or something else
    let locale = currentURL.split('/')[4];

    // if they are on the base url without being in seq or qld locale will be undefined
    if (typeof locale === 'undefined') {
        locale = 'none';
    }

    if (locale !== 'seq' && locale !== 'qld' && locale !== 'none') {
        locale = 'none';
    }

    return locale;
}
